import { Link } from "react-router-dom";

export function Logo({ className = "" }) {
  return (
    <Link to="/" data-testid="logo-link" className={`flex items-center gap-2.5 group ${className}`}>
      <span className="relative flex h-9 w-9 items-center justify-center rounded-xl bg-primary shadow-sm transition-transform group-hover:-rotate-6">
        <span className="flex flex-col gap-[3px]">
          <span className="block h-[3px] w-5 rounded-full bg-primary-foreground/90" />
          <span className="block h-[3px] w-5 rounded-full bg-primary-foreground/60" />
          <span className="block h-[3px] w-5 rounded-full bg-primary-foreground/90" />
        </span>
      </span>
      <span className="text-xl font-extrabold tracking-tight leading-none">
        Palete<span className="text-primary">Lab</span>
      </span>
    </Link>
  );
}
